import { DELETE_CPIR } from "../actions/types";

const initialState = {
  items: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE_CPIR:
      return {
        ...state,
        items: action.payload,
      };
    default:
      return state;
  }
}
